








































































































































































import Loading from 'vue-loading-overlay';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    StoreHelper,
    VehicleCompanyStoreHelper
} from '../../core/mixins';
import { FetchCompanyResponse, FilterDateEvent, ID } from '../../core/utils/types';
import { EventBus, formattedDate, getAlertColorByPriority, getCurrentTimestamp, getDateFromDateFormatApi, getIndexFromList, goToUrl, isEmptyObject, NAME_ROUTES, PRIVILEGE_KEYS, PRIVILEGE_TYPES, sortObjectByPropertyName, TypeEventBus } from '../../core/utils';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import { booleanFormatter, formatList } from '../../core/utils/table-formatters';
import Axios from 'axios';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import ModalCompaniesActions from '../../settings/components/ModalCompaniesActions.vue';
import { PageTitle } from '../../core/components';
import ModalAddCompany from '../components/ModalAddCompany.vue';
import  Button from '../../core/components/Button.vue';
import  SectionTitle from '../../core/components/SectionTitle.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Input from '../../core/components/Input.vue';
import Combobox from '../../core/components/Combobox.vue';
import { CompanyListItem, CompanyDetail  } from '../models/Companies';
import { AuthEvent } from '../../../store';
import { CompaniesService } from '../api/CompaniesService';

@Component({
    components: { 
        Loading, 
        PageTitle,
        Input,
        SectionTitle,
        SimpleTable,
        Button,
        DeleteConfirmation,
        Combobox,
        ModalAddCompany,
        ModalCompaniesActions
    }
})
export default class CompaniesPage extends Mixins(
    StoreHelper,
    RootStoreHelper,
    VehicleCompanyStoreHelper,
    NotificationStoreHelper,
    AuthStoreHelper
) {
    visibleModalAddCompany: boolean = false;
    itemsTable: Array<CompanyListItem> = [];
    selectedCompanies: Array<CompanyListItem> = [];
    companyToPatch: CompanyListItem | null = null;
    headers: Array<object> = [
        {
            text: 'ID',
            align: 'left',
            value: 'id'
        },
        {
            text: 'Nombre',
            align: 'left',
            value: 'name'
        },
        {
            text: 'Nro vehículos',
            align: 'center',
            value: 'vehicles',
        },
        {
            text: 'Módulos',
            align: 'left',
            value: 'modules',
        },
        {
            text: 'Deudor',
            align: 'center',
            value: 'debt',
            filter: this.filterByDebt
        },
        {
            text: 'Servicio Suspendido',
            align: 'center',
            value: 'suspended',
            formatter: booleanFormatter,
            filter: this.filterBySuspendedValue
        },
        {
            text: 'Límite de Msgs (texto)',
            align: 'center',
            value: 'message_limit',
        },
        {
            text: 'Aseguradora',
            align: 'center',
            value: 'is_insurance',
            formatter: booleanFormatter,
            filter: this.filterByInsurance
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];
    pendingCompanies: boolean = false;
    confirmationDelete: boolean = false;
    visibleCompanyActions: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    companyIdToRemove: number = -1;
    search: string = '';
    insuranceFilterValue: string = 'null';
    filtersSuspendedSelected: object | null = null;
    clearSuspendedCombo: boolean = false;
    filtersDebtSelected: object | null = null;
    filtersDebtRv: boolean = false;
    filtersInsuranceSelectedRv: boolean = false;
    booleanOptions: Array<object> = [
        {
            name: 'Si',
            value: true
        },
        {
            name: 'No',
            value: false
        }
    ];
    insuranceOptions: any = this.booleanOptions
    filtersInsuranceSelected: object | null = null;
    debtOptions: any = this.booleanOptions;
    suspendedOptions: Array<object> = this.booleanOptions;
    companyToUpdate: CompanyDetail | null = null;

    clearSelectedCompaniesInTable(){
        this.updatedSelectedCompanies([]);
    }

    updateCompaniesDebt(companiesIds: ID[], newDebtValue: boolean){
        this.clearSelectedCompaniesInTable();
        this.pendingRequest(true);
        for (let index = 0; index < companiesIds.length; index++) {
            const currentCompanyId: ID = companiesIds[index];
            let indexInList = getIndexFromList(this.itemsTable, 'id', currentCompanyId);
            if(indexInList !== -1){
                this.$set(this.itemsTable[indexInList], 'debt', newDebtValue);
            }
        }
        this.pendingRequest(false);
    }

    updateSuspendServices(companiesIds: ID[], newSuspendedValue: boolean){
        //actualizo servicio suspendido en las empresas
        this.clearSelectedCompaniesInTable();
        this.pendingRequest(true);
        for (let index = 0; index < companiesIds.length; index++) {
            const currentCompanyId: ID = companiesIds[index];
            let indexInList = getIndexFromList(this.itemsTable, 'id', currentCompanyId);
            if(indexInList !== -1){
                this.$set(this.itemsTable[indexInList], 'suspended', newSuspendedValue);
            }
            this.checkIfCompanyIsCurrentlySelected(this.itemsTable[indexInList]);
        }
        this.updateSuspendedCompaniesInGlobalState(companiesIds, newSuspendedValue);
        this.pendingRequest(false);
    }

    checkIfCompanyIsCurrentlySelected(suspendedCompany: CompanyListItem){
        if(
            suspendedCompany.suspended && 
            this.$_getSelectedCompanyById == suspendedCompany.id &&
            !this.$_getSmartwayMember
            ){
            //quito la empresa seleccionada actual si fue marcada como suspendida
            this.$_selectCompany(null);
        }
    }

    updateSuspendedCompaniesInGlobalState(companiesIds: ID[], newSuspendedValue: boolean){
       this.$_setCompaniesSuspended({
        companiesIds: companiesIds,
        isSuspended: newSuspendedValue
       })
    }

    get getSelectedCompanies(){
        if(this.selectedCompanies.length !== 0){
            return this.selectedCompanies
        }
        return []
    }

    visibilityCompaniesActions(value){
        this.visibleCompanyActions = value;
    }


    unsubscribe: () => void;

    updatedSelectedCompanies(selectedCompanies: Array<CompanyListItem>){
        this.selectedCompanies = selectedCompanies;
    }

    companyExistInList(companyId: number){
        if(getIndexFromList(this.itemsTable, 'id', companyId) !== -1){
            return true
        }
        return false
    }

    refreshCompaniesSaved(){
        this.$_fetchCompanies(this.$_isMock)
        .then((response: FetchCompanyResponse) => {
            EventBus.$emit(TypeEventBus.USER_DOUBT);
            if (!isEmptyObject(response.companies)) {
                this.$_setCompanies(response.companies);
            }
        })
    }

    addNewCompanyToList(newCompany: CompanyListItem){
        if(!this.companyExistInList(newCompany.id)){
             this.refreshCompaniesSaved();
            this.itemsTable.push(newCompany);
        }
    }
    updateCompanyInList(newCompany: CompanyListItem){
        let indexCompanyToUpdate = getIndexFromList(this.itemsTable, 'id', newCompany.id);
        if(indexCompanyToUpdate !== -1){
            this.$set(this.itemsTable[indexCompanyToUpdate], 'name', newCompany.name);
            this.$set(this.itemsTable[indexCompanyToUpdate], 'address', newCompany.address);
            this.$set(this.itemsTable[indexCompanyToUpdate], 'rut', newCompany.rut);
            this.$set(this.itemsTable[indexCompanyToUpdate], 'debt', newCompany.debt);
            this.$set(this.itemsTable[indexCompanyToUpdate], 'has_to_accept_tyc', newCompany.has_to_accept_tyc);
            this.$set(this.itemsTable[indexCompanyToUpdate], 'message_limit', newCompany.message_limit);
            this.$set(this.itemsTable[indexCompanyToUpdate], 'driving_period', newCompany.driving_period);
            this.$set(this.itemsTable[indexCompanyToUpdate], 'vehicles', newCompany.vehicles);
            this.$set(this.itemsTable[indexCompanyToUpdate], 'is_insurance', newCompany.is_insurance);
            this.refreshCompaniesSaved();
        }
    }

    updateInsuranceKey(value: boolean){
        if(this.companyToUpdate){
            this.companyToUpdate.is_insurance = value;
            let indexInList = getIndexFromList(this.itemsTable, 'id', this.companyToUpdate.id);
            if(indexInList !== -1){
                this.$set(this.itemsTable[indexInList], 'is_insurance', value);
            }
        }
    }

    created(){
        this.unsubscribe = this.$store.subscribe((mutation, stateList) => {
            if (mutation.type !== AuthEvent.SET_PRIVILEGES) return;
            this.checkPermissions();
        });
    }

    visibilityModalAddCompany(value: boolean){
        this.visibleModalAddCompany = value;
    }

    updateSearchValue(value){
        this.search = value;
    }


    checkPermissions() {
        if (!this.shouldReadCompanies) {
            this.$router.push(NAME_ROUTES.HOME.path);
        }
    }

    get shouldReadCompanies(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.VEHICLES, PRIVILEGE_TYPES.READ);
    }
     getAlertColor(value) {
        return getAlertColorByPriority(value);
    }
        
    @Watch('$route', { immediate: true, deep: true })
    onUrlChange() {
        this.getCompanies();
    }

    getCompanies(){
        this.pendingRequest(true);
        this.setCompanies([])
        CompaniesService.getAllCompanies()
            .then((res) => {
                this.setCompanies(res);
                this.pendingRequest(false);
            }).catch((err) => {
                this.$_catchLoadingDialog({
                    response: err.response.data || {},
                    alternative_msg: 'No se pudo traer el listado de compañías'
                });
                this.pendingRequest(false);
            })
    }

    createReport(){
        // console.log("create report");
    }


    setCompanies(items){
        this.itemsTable = items;
    }

    pendingRequest(value){
        this.pendingCompanies = value;
    }

    filterByDebt(value: CompanyListItem["debt"]){
        if (this.filtersDebtSelected == null) {
            return true;
        }
        return value === this.filtersDebtSelected['value']
    }

    filterByInsurance(value: CompanyListItem["is_insurance"]){
        if (this.filtersInsuranceSelected == null) {
            return true;
        }
        return value === this.filtersInsuranceSelected['value']
    }

    filterBySuspendedValue(value: boolean): boolean {
        if(this.filtersSuspendedSelected == null){
            return true
        }
        return value == this.filtersSuspendedSelected['value']
    }


    seeCompanyDetail(item){
        this.$set(item, 'isLoading', true);
        CompaniesService.getCompanyById(
            item['id']
        ).then((res:CompanyDetail) => {
            this.companyToUpdate = res;
            this.visibilityModalAddCompany(true);
            this.$set(item, 'isLoading', false);
        }).catch((err) => {
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudo traer el detalle de la compañia'
            })
            this.$set(item, 'isLoading', false);
        })
        
    }

    updateSuspendedSelected(value){
        this.filtersSuspendedSelected = value;
    }
    clearSuspendedCombobox(value){
        this.clearSuspendedCombo = value;
    }
    updateFiltersDebtSelected(value){
        this.filtersDebtSelected = value;
    }
    updateFiltersDebtRv(value){
        this.filtersDebtRv = value;
    }
    updateFiltersInsuranceSelected(value){
        this.filtersInsuranceSelected = value;
    }
    updateFiltersInsuranceRv(value){
        this.filtersInsuranceSelectedRv = value;
    }
    clearFilters(){
        this.updateFiltersDebtSelected(null);
        this.updateFiltersInsuranceSelected(null);
        this.updateSearchValue('');
    }
    createCompanyAction(){
        this.companyToUpdate = null;
        this.visibilityModalAddCompany(true)
    }
    updateServicesForCompany(payload){
        let indexCompanyToUpdate = getIndexFromList(this.itemsTable, 'id', payload.company_id);
        if(indexCompanyToUpdate !== -1){
            this.$set(this.itemsTable[indexCompanyToUpdate]['modules'], 'journey', payload.has_active_journey)
            this.$set(this.itemsTable[indexCompanyToUpdate]['modules'], 'peritaje', payload.has_peritaje_active)
            this.$set(this.itemsTable[indexCompanyToUpdate]['modules'], 'guardian', payload.has_active_guardian)
        }
    }

   


    mounted() {
        EventBus.$on(TypeEventBus.UPDATE_COMPANY_JOURNEY_SERVICES, (payload) => {
            this.updateServicesForCompany(payload);
        });
    }

}
